<script setup lang="ts">
const defectId = defineModel<string | undefined>('defectId', { required: true })
</script>

<template>
  <ThePopup :show="!!defectId" :title="$t('customerModule.defect.comments.popUp.title')" @close="defectId = undefined">
    <CustomerModuleCommentList v-if="defectId" :entity-id="defectId" type="Defect" sort="desc" allow-access-all-public-comments />
  </ThePopup>
</template>
